import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/20/solid";
import { FC, useState } from "react";

import { useSelector } from "react-redux";

import { useMutation } from "@tanstack/react-query";
import { Button, DatePicker, Dropdown, Flex, Menu, Space, message } from "antd";
import { queryKeys } from "../../../services/react-query/queryKeys";

import { CloseOutlined, MoreOutlined, PlusOutlined } from "@ant-design/icons";
import arLocale from "antd/es/date-picker/locale/ar_EG";
import enLocale from "antd/es/date-picker/locale/en_US";
import dayjs from "dayjs";
import { useIntl } from "react-intl";
import { editTeamMember } from "../../../network/teamMember";
import queryClient from "../../../services/react-query/queryClient";
import { weekEnd, weekStart } from "../../../utils/DateUtils";
import AddTimeOff from "./AddTimeOff";
import AddServiceForm from "./addShift/Main";
interface CalendarHeaderProps {
  // teamMemberData: teamMember & { locations: Location[] };
  teamMemberData: any;
  locationId: number;
  setSelectedDate: React.Dispatch<React.SetStateAction<Date>>;
  selectedDate: Date;
}

const CalendarHeader: FC<CalendarHeaderProps> = ({
  locationId,
  teamMemberData,
  selectedDate,
  setSelectedDate,
}) => {
  const intl = useIntl();
  const { currentLang } = useSelector(
    (state: { user: { currentLang: "en" | "ar" } }) => state.user
  );
  const [openModal, setOpenModal] = useState<"shift" | "dayOff" | null>(null);

  const changeDate = (changeType: "next" | "prev") => {
    const newDate = new Date(selectedDate);
    if (changeType === "next") {
      newDate.setDate(selectedDate.getDate() + 7);
    } else if (changeType === "prev") {
      newDate.setDate(selectedDate.getDate() - 7);
    }
    setSelectedDate(newDate);
  };

  const { mutate: editMutation, isLoading } = useMutation<
    void,
    unknown,
    { location_permissions: { location_id: number; permission: string }[] }
  >((params) => editTeamMember(teamMemberData?.id, params), {
    onSuccess: (res) => {
      message.success("Edit success!");
      queryClient.invalidateQueries([queryKeys.listSpacficTeamMemer]);
    },
    onError: (error) => {
      message.error("حاول مرة اخرى");
    },
  });

  const handleRemoveLocation = (locationId: number) => {
    const permission = teamMemberData?.locations?.find(
      (loc: { id: number; pivot: { permission: string } }) =>
        loc.id === locationId
    )?.pivot?.permission;
    console.log(permission, "permission");
    if (
      teamMemberData?.locations.some(
        (loc: { id: number }) => loc.id === locationId
      )
    ) {
      const updatedLocations = teamMemberData?.locations.filter(
        (loc: { id: number }) => loc.id !== locationId
      );
      const updatedLocationIds = updatedLocations.map(
        (loc: { id: number }) => loc.id
      );
      editMutation({
        location_permissions: updatedLocationIds.map((location_id: any) => ({
          location_id,
          permission,
        })),
      });
    } else {
      message.error(
        intl.formatMessage({ id: "tryAgain", defaultMessage: "حاول مرة اخرى" })
      );
    }
  };
  const onChangeDatePicker = (value: any) => {
    setSelectedDate(new Date(value?.format("YYYY-MM-DD") || ""));
  };
  const weekFormat = "MM/DD";

  return (
    <div className="flex flex-col md:flex-row gap-2 justify-center items-center md:justify-between  rounded-md  border-none  px-6 py-4">
      <div className="flex justify-between gap-2 w-full md:w-fit">
        <p className="mt-1 md:mt-0">
          {intl.formatMessage({
            id: "memberWorkingHours",
            defaultMessage: "الدوام الخاص بالعضو",
          })}
        </p>
        <Flex justify="flex-end" className=" block md:hidden ">
          <Dropdown
            className=""
            overlay={
              <Menu>
                <Menu.Item
                  key="Day Off"
                  onClick={() => {
                    setOpenModal("dayOff");
                  }}
                >
                  <p
                  // className="text-color-sec-title flex gap-1 px-2 "
                  // style={{ borderBottom: '1px solid' }}
                  >
                    <PlusOutlined className="ml-1" />
                    <span>
                      {intl.formatMessage({
                        id: "addVacation",
                        defaultMessage: "أضف عطلة",
                      })}
                    </span>
                  </p>
                </Menu.Item>
                <Menu.Item
                  key="Shift"
                  onClick={() => {
                    setOpenModal("shift");
                  }}
                >
                  <p
                  // className="text-color-sec-title flex gap-1 px-2 "
                  // style={{ borderBottom: '1px solid' }}
                  >
                    <PlusOutlined className="ml-1" />
                    <span>
                      {intl.formatMessage({
                        id: "workingShift",
                        defaultMessage: "دوام كامل",
                      })}
                    </span>
                  </p>
                </Menu.Item>
                <Menu.Item
                  key="delete from branch"
                  danger
                  onClick={() => handleRemoveLocation(locationId)}
                >
                  <p
                  // className="text-color-sec-title flex gap-1 px-2 items-center"
                  >
                    {/* <span>&#x2715;</span> */}
                    <CloseOutlined className="ml-1" />
                    <span>
                      {intl.formatMessage({
                        id: "deleteMemebrFromBranch",
                        defaultMessage: "الغاء التعيين من الفرع",
                      })}
                    </span>
                  </p>
                </Menu.Item>
              </Menu>
            }
          >
            <Button className="border-none bg-transparent shadow-none outline-none p-2">
              <Space>
                <MoreOutlined />
              </Space>
            </Button>
          </Dropdown>
        </Flex>
      </div>
      {/* <DatePicker picker="week" format={'YYYY-MM-DD'} /> */}
      <Flex justify="center">
        <div className="relative flex items-center border-none rounded-md bg-white ">
          <button
            type="button"
            className="flex items-center  cursor-pointer bg-white border-none justify-center rounded-l-md py-2 pl-3 pr-4 text-gray-400  focus:relative md:w-9 md:px-2"
            onClick={() => changeDate("prev")}
          >
            <ChevronRightIcon
              className={
                currentLang === "ar" ? "h-5 w-5" : "h-5 w-5 rotate-180 "
              }
              aria-hidden="true"
            />
          </button>
          <button
            type="button"
            className="   px-3.5 text-base font-semibold bg-white border-none text-gray-900 focus:relative md:block"
          >
            {/* {formatWeekText(selectedDate)} */}
            <DatePicker
              locale={currentLang === "en" ? enLocale : arLocale}
              onChange={onChangeDatePicker}
              picker={"week"}
              value={dayjs(selectedDate)}
              size="large"
              popupClassName="max-w-[250px]"
              allowClear={false}
              variant="borderless"
              style={{ width: "100%" }}
              format={(value: any) => {
                // return `${dayjs(value)
                //   .startOf("week")
                //   .subtract(1, "days")
                //   .format(weekFormat)} ~ ${dayjs(value)
                //   .endOf("week")
                //   .subtract(1, "days")
                //   .format(weekFormat)}`;

                return `${dayjs(weekStart(value)).format(weekFormat)} ~ ${dayjs(
                  weekEnd(value)
                ).format(weekFormat)}`;
              }}
            />
          </button>

          <button
            type="button"
            className="cursor-pointer  flex  items-center justify-center bg-white border-none rounded-r-md py-2 pl-4 pr-3 text-gray-400 focus:relative md:w-9 md:px-2"
            onClick={() => changeDate("next")}
          >
            <ChevronLeftIcon
              className={
                currentLang === "ar" ? "h-5 w-5 " : "h-5 w-5  -rotate-180"
              }
              aria-hidden="true"
            />
          </button>
          <span className="relative -mx-px h-5 w-px bg-gray-300 md:hidden" />
        </div>
      </Flex>
      {/* <Modal open={openModal !== null} onCancel={() => setOpenModal(null)}> */}
      {openModal === "shift" ? (
        <AddServiceForm
          visible={openModal === "shift"}
          location_id={locationId}
          onClose={() => setOpenModal(null)}
          selectedDate={selectedDate}
          team_member_id={teamMemberData?.id}
        />
      ) : (
        <AddTimeOff
          onClose={() => setOpenModal(null)}
          team_member_id={teamMemberData?.id}
          selectedDate={selectedDate}
          visible={openModal === "dayOff"}
          location_id={locationId}
        />
      )}
      {/* </Modal> */}
      <Flex justify="flex-end" className="hidden md:block">
        <Dropdown
          className="float-left block"
          overlay={
            <Menu>
              <Menu.Item
                key="Day Off"
                onClick={() => {
                  setOpenModal("dayOff");
                }}
              >
                <p
                // className="text-color-sec-title flex gap-1 px-2 "
                // style={{ borderBottom: '1px solid' }}
                >
                  <PlusOutlined className="ml-1" />
                  <span>
                    {intl.formatMessage({
                      id: "addVacation",
                      defaultMessage: "أضف عطلة",
                    })}
                  </span>
                </p>
              </Menu.Item>
              <Menu.Item
                key="Shift"
                onClick={() => {
                  setOpenModal("shift");
                }}
              >
                <p
                // className="text-color-sec-title flex gap-1 px-2 "
                // style={{ borderBottom: '1px solid' }}
                >
                  <PlusOutlined className="ml-1" />
                  <span>
                    {intl.formatMessage({
                      id: "workingShift",
                      defaultMessage: "دوام كامل",
                    })}
                  </span>
                </p>
              </Menu.Item>
              <Menu.Item
                key="delete from branch"
                danger
                onClick={() => handleRemoveLocation(locationId)}
              >
                <p
                // className="text-color-sec-title flex gap-1 px-2 items-center"
                >
                  {/* <span>&#x2715;</span> */}
                  <CloseOutlined className="ml-1" />
                  <span>
                    {intl.formatMessage({
                      id: "deleteMemebrFromBranch",
                      defaultMessage: "الغاء التعيين من الفرع",
                    })}
                  </span>
                </p>
              </Menu.Item>
            </Menu>
          }
        >
          <Button className="border-none bg-transparent shadow-none outline-none p-2">
            <Space>
              <MoreOutlined />
            </Space>
          </Button>
        </Dropdown>
      </Flex>
    </div>
  );
};

export default CalendarHeader;
